import jupiter from "../assets/Jupiter.mp4";
import moon from "../assets/Lune.mp4";
import saturn from "../assets/Saturne.mp4";
import soleil from "../assets/Soleil.mp4";

const data = {
  articlesVoyage: [
    {
      media: jupiter,
      title: "Dinner on Jupiter",
      description:
        'Jupiter is one of the 4 telluric planets of the Solar System. Colder than the Earth, the average temperature on its surface is -67°C. It is called the "red planet" because its rocky and desert surface is covered with a dust rich in iron oxide of reddish color. There are also many high volcanoes and deep canyons.',
      activities:
        "Jupiter: Wanna dazzle your friends with the best view out of town ? You found it. Book a private diner on Mars and enjoy the most beautiful view of Earth, Venus and Mercury.",
    },
    {
      media: moon,
      title: "Wedding on the Moon",
      description:
        "The Moon, or Earth Ib, is the only permanent natural satellite of the planet Earth. It is the fifth largest natural satellite in the Solar System, and the largest of the planetary satellites relative to the size of the planet around which it orbits.",
      activities:
        "Spend your most memorable day on a memorable place. The priest of you choice will be waiting for you to start celebrate the marriage. A photographer is enclosed in this trip so you will come back down to Earth with every memories with you.",
    },
    {
      media: saturn,
      title: "Business trip to Saturn",
      description:
        "Saturn is the sixth planet in the Solar System in order of distance from the Sun, and the second largest in size and mass after Jupiter, which is like it a gas giant planet. Orbiting on average at about 1.4 billion kilometers from the Sun",
      activities:
        "Looking for a really cool spot for your team building ? This trip is for you. All-inclusive business trip to get the best work-leisure balance with your team.",
    },
    {
      media: soleil,
      title: "Lava Land",
      description:
        "The Sun is the star of the Solar System. In astronomical classification, it is a yellow dwarf star. The Sun is part of the galaxy called the Milky Way and is located about 8 kpc from the galactic center, in the Orion arm. The Sun orbits the galactic center in a galactic year of 225 to 250 million years.",
      activities:
        "You already know about AquaLand, come discover Lavaland! A brand new amusement park.",
    },
  ],
};

export default data;
